module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo8-143eaa8dd1e62575bd399e95debda9ad.jpg";